import { useState, useEffect, useCallback } from'react';

type Theme ='light' |'dark' |'system';

function getSystemTheme():'light' |'dark' {
 return window.matchMedia('(prefers-color-scheme: dark)').matches ?'dark' :'light';
}

function applyTheme(theme: Theme) {
 const resolved = theme ==='system' ? getSystemTheme() : theme;
 if (resolved ==='dark') {
 document.documentElement.classList.add('dark');
 } else {
 document.documentElement.classList.remove('dark');
 }
}

export function useTheme() {
 const [theme, setThemeState] = useState<Theme>(() => {
 const stored = localStorage.getItem('theme') as Theme | null;
 return stored || 'light';
 });

 const setTheme = useCallback((newTheme: Theme) => {
 setThemeState(newTheme);
 if (newTheme ==='system') {
 localStorage.removeItem('theme');
 } else {
 localStorage.setItem('theme', newTheme);
 }
 applyTheme(newTheme);
 }, []);

 // Cycle through: system -> light -> dark -> system
 const toggleTheme = useCallback(() => {
 setTheme(theme ==='system' ?'light' : theme ==='light' ?'dark' :'system');
 }, [theme, setTheme]);

 useEffect(() => {
 applyTheme(theme);
 if (theme ==='system') {
 const mq = window.matchMedia('(prefers-color-scheme: dark)');
 const handler = () => applyTheme('system');
 mq.addEventListener('change', handler);
 return () => mq.removeEventListener('change', handler);
 }
 }, [theme]);

 const resolvedTheme = theme ==='system' ? getSystemTheme() : theme;

 return { theme, resolvedTheme, setTheme, toggleTheme };
}
